export const apiName: string = 'sub-tipos-bens';
export const bemSubtiposModuleName: any = {plural: 'Subtipos de Bens', single: 'Subtipo de Bem'};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-subtipos/shared/data.service.ts
 **/